import React from 'react';
import ExamCard from '../ExamCard/index';
import HamburgerMenu from '../HamburgerMenu';
import { ExamListContainer, SeriesGrid, LoadingMessage, ErrorMessage } from './styles';

const ExamList = ({
  loading,
  error,
  selectedRecord,
  onSeriesSelect,
  loadDicomImage,
  organizedRecords,
  zipFiles,
  loadedImages,
  setLoadedImages,
  isMenuOpen,
  setIsMenuOpen,
}) => {
  return (
    <>
      <HamburgerMenu isOpen={isMenuOpen} toggleMenu={() => setIsMenuOpen(!isMenuOpen)} />
      <ExamListContainer className={`exam-list ${isMenuOpen ? 'open' : ''}`}>
        <SeriesGrid className="series-grid">
          {loading && <LoadingMessage className="loading">Carregando...</LoadingMessage>}
          {error && <ErrorMessage className="error">{error}</ErrorMessage>}
          {Object.entries(organizedRecords).map(([seriesId, series]) => (
            <ExamCard
              key={seriesId}
              exam={{
                ...series,
                images: series.images,
                date: series.seriesDate,
                description: series.seriesDescription,
              }}
              onClick={() => {
                series.images[0] && onSeriesSelect(series, series.images[0]);
                if (window.innerWidth <= 768) {
                  setIsMenuOpen(false);
                }
              }}
              selected={selectedRecord && series.images.some((img) => img === selectedRecord)}
              loadDicomImage={loadDicomImage}
              zipFiles={zipFiles}
              loadedImages={loadedImages}
              setLoadedImages={setLoadedImages}
              className={
                selectedRecord && series.images.some((img) => img === selectedRecord)
                  ? 'selected-series'
                  : ''
              }
            />
          ))}
        </SeriesGrid>
      </ExamListContainer>
    </>
  );
};

export default ExamList;
